//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "SearchPagination",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "searchQuery",
      "results",
      "currentResultsStart",
      "currentResultsEnd",
      "totalResultCount"
    ]),
    currentPage() {
      return this.searchQuery.currentPage;
    },
    enablePrev() {
      return this.currentPage > 0;
    },
    enableNext() {
      return this.currentPage < this.results.totalPages - 1;
    },
  },
  methods: {
    ...mapMutations(["setPageIndex"]),
    checkPaginationVisibility(i) {
      let cp = this.currentPage;
      let tp = this.results.totalPages;

      if (tp <= 9) return true;
      if (i === 0) return true
      if (i === tp - 1) return true

      if (cp < 4) {
        if (i < 4) return true;
      }

      if (Math.abs(cp - i) <= 2) return true

      if (cp > tp - 5) {
        if (i > tp - 5) return true;
      }

      return false;
    },
		topScroll() {
			let content = document.querySelector('.content');
			setTimeout(() => {
				document.body.scrollTop = content.offsetTop;
				document.documentElement.scrollTop = content.offsetTop;
			},500);
		},
    selectIndex(index) {
      this.setPageIndex(index);
      this.submitPage();
			this.topScroll();
    },
    moveIndex(increment) {
      this.setPageIndex(this.currentPage + increment);
      this.submitPage();
			this.topScroll();
    },
    submitPage() {
      this.$emit("submitpage");
    },
    keyboardNavigation(e) {
      if (e.code == "ArrowRight" && this.enableNext) {
        this.moveIndex(1);
        this.submitPage;
      }
      if (e.code == "ArrowLeft" && this.enablePrev) {
        this.moveIndex(-1);
        this.submitPage;
      }
    },
  },
  created() {
    let previousEventCallback = window.searchPaginationKeyboardEvent || false;
    let newEventCallback = this.keyboardNavigation;
    if (previousEventCallback) {
      window.removeEventListener("keydown", previousEventCallback);
    }
    window.addEventListener("keydown", newEventCallback);
    window.searchPaginationKeyboardEvent = this.keyboardNavigation;
  },
};
